import {gql} from "@apollo/client/core";

export const ShopSessionDashboardShareFragment = gql`
    fragment ShopSessionDashboardShareFragment on ShopSessionDashboard {
        localeTotals {
            locale
            sessions
            events
            associateEnrolls
            affiliateEnrolls
            pcEnrolls
            pcEnrollsWithOrder
            cartOrders
            updatedCartOrders
            pendingOrders
        }
    }
`;
